export const getWindowSizes = () => {
	const innerWidth = window.innerWidth
	const innerHeight = window.innerHeight

	return { innerWidth, innerHeight }
}
